export const CARD_ACTION_TYPES = {
    SET_CARD_DATA: 'card/SET_CARD_DATA',
    SET_CHECKLIST_DATA: 'card/SET_CHECKLIST_DATA',
    APPEND_CHECKLIST_DATA: 'card/APPEND_CHECKLIST_DATA',
    SET_CHECKLIST_PAGINATION: 'card/SET_CHECKLIST_PAGINATION',
    SET_CHECKLIST_CARD_IDS: 'card/SET_CHECKLIST_CARD_IDS',
    SET_PARALLEL_DATA: 'card/SET_PARALLEL_DATA',
    SET_CHECKLIST_METADATA: 'card/SET_CHECKLIST_METADATA',
    SET_QUEUED_CARDS: 'card/SET_QUEUED_CARDS',
    SET_QUEUED_CARDS_QTY: 'card/SET_QUEUED_CARDS_QTY',
    SET_QUEUED_CARDS_DISPLAY: 'card/SET_QUEUED_CARDS_DISPLAY',
    SET_QUEUED_CARDS_DISPLAY_QTY: 'card/SET_QUEUED_CARDS_DISPLAY_QTY',
    SET_CARD_COLLECTION: 'card/SET_CARD_COLLECTION',
    SET_CARD_COLLECTION_QTY: 'card/SET_CARD_COLLECTION_QTY',
    UPDATE_CARD_DATA_QUANTITY: 'card/UPDATE_CARD_DATA_QUANTITY',
    CLEAR_QUEUE: 'card/CLEAR_QUEUE',
    RESET_CARD_STATE: 'card/RESET_CARD_STATE',
    SET_CHECKLIST_CACHE: 'card/SET_CHECKLIST_CACHE',
    CLEAR_CHECKLIST_CACHE: 'card/CLEAR_CHECKLIST_CACHE',
    CLEAR_CHECKLIST_CACHE_BY_SERIES: 'card/CLEAR_CHECKLIST_CACHE_BY_SERIES',
    SET_VIEWING_CARD_DATA: 'card/SET_VIEWING_CARD_DATA',
    CLEAR_VIEWING_CARD_DATA: 'card/CLEAR_VIEWING_CARD_DATA',
    INVALIDATE_COLLECTION: 'card/INVALIDATE_COLLECTION'
};